import { IDirectoryLocation } from "../src/taskpane/config/config";
import { ISiteInfoLocation } from "../src/taskpane/interfaces/ISiteInfo";

export class TreeStructureModule {
    private locations: IDirectoryLocation[] = [];
    private combinedSitesAndTeams: ISiteInfoLocation[] = [];
    private allTeams: ISiteInfoLocation[] = [];

    public isFolderInOneDrive: boolean = false;

    setLocations(locations: IDirectoryLocation[]) {
        this.locations = locations;
    }

    setSites(sites: ISiteInfoLocation[]) {
        this.combinedSitesAndTeams = sites;
    }

    setTeams(teams: ISiteInfoLocation[]) {
        this.allTeams = teams;
    }

    setIsFolderInOneDrive(inOneDrive: boolean) {
        this.isFolderInOneDrive = inOneDrive;
    }

    getLocations() {
        return this.locations;
    }

    getSites() {
        return this.combinedSitesAndTeams;
    }

    getTeams() {
        return this.allTeams;
    }

    getIsFolderInOneDrive() {
        return this.isFolderInOneDrive;
    }

    reset() {
        this.locations = [];
        this.combinedSitesAndTeams = [];
        this.allTeams = [];
    }
}

const treeStructureModule = new TreeStructureModule();
export default treeStructureModule;